import { ColorPicker } from 'antd';
import React from 'react';
export const ColorPickerPanel = (props) => React.createElement(ColorPicker, props);
export default ColorPickerPanel;
